<div style="display:flex; flex-direction:row; align-items:flex-start;">
    <mat-form-field appearance="fill">
        <mat-label>Shipment Number</mat-label>
        <input matInput #inventoryID [(ngModel)]="shipmentNbr" (keydown.enter)="keyedReceiveShipment()" autofocus />
    </mat-form-field>
    <button mat-raised-button color="primary" type="button" (click)="keyedReceiveShipment()"
        style="margin-top:1em; margin-left: 0.5em;">Receive It</button>
</div>

<div *ngIf="unreceivedShipments?.length !== 0" style="font-size: 1.2em; text-decoration:underline;">Unreceived Shipments
</div>
<div *ngIf="unreceivedShipments === undefined">
    <mat-spinner [diameter]="20" style="display:inline-block;"></mat-spinner> Checking for Unreceived Shipments
</div>
<mat-accordion *ngIf="unreceivedShipments?.length">
    <mat-expansion-panel *ngFor="let shipment of unreceivedShipments" (opened)="loadShipment(shipment.ShipmentNbr)">
        <mat-expansion-panel-header>
            <mat-panel-title>
                {{shipment.ShipmentNbr}}
            </mat-panel-title>
            <mat-panel-description>
                {{shipment.ShipmentDate | date:'mediumDate'}}
            </mat-panel-description>
        </mat-expansion-panel-header>
        <div *ngIf="!shipmentDocs[shipment.ShipmentNbr]">
            <mat-spinner [diameter]="20" style="display:inline-block;"></mat-spinner> Getting Shipment Details...
        </div>
        <div *ngIf="shipmentDocs[shipment.ShipmentNbr]">
            <table>
                <thead>
                    <tr>
                        <td>Inventory ID</td>
                        <td>Description</td>
                        <td>Shipped</td>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let detail of shipmentDocs[shipment.ShipmentNbr].Details">
                        <td>{{detail.InventoryID}}</td>
                        <td>{{detail.Description}}</td>
                        <td>{{detail.ShippedQty}} {{detail.UOM}}</td>
                    </tr>
                </tbody>
            </table>
            <button mat-raised-button color="accent" (click)="trackShipment(shipment.ShipmentNbr)">Track
                Shipment</button>
            <button mat-raised-button color="primary" (click)="clickReceiveShipment(shipment.ShipmentNbr)"
                style="float:right">Shipment Received</button>
        </div>
    </mat-expansion-panel>
</mat-accordion>

<div *ngIf="receipt">
    <hr />
    <h3>Shipment Received: {{shipmentNbr}}<br />Receipt Nbr: {{receipt?.ReceiptNbr}}</h3>
    <table style="width:95vw;">
        <thead>
            <tr>
                <td>Inventory ID</td>
                <td>Description</td>
                <td>Qty</td>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let detail of receipt.Details">
                <td>{{detail.InventoryID}}</td>
                <td>{{detail.Description}}</td>
                <td>x{{detail.ReceiptQty}} {{detail.UOM}}</td>
            </tr>
        </tbody>
    </table>
</div>